import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { BaseResourceService } from '@kailona/core';
import mapFromFHIR from '../mappers/mapFromFHIR';
import { mapToFHIRLeukocytes, mapToFHIRHemoglobin, mapToFHIRPlatelets, mapToFHIRLymphocytes, mapToFHIRNeutrophils, mapToFHIREosinophils, mapToFHIRBasophils, mapToFHIRMonocytes, mapToFHIRSBCPanel } from '../mappers/mapToFHIR';

var LaboratoryService = /*#__PURE__*/function (_BaseResourceService) {
  _inherits(LaboratoryService, _BaseResourceService);

  var _super = _createSuper(LaboratoryService);

  function LaboratoryService() {
    _classCallCheck(this, LaboratoryService);

    return _super.call(this, 'Observation');
  }

  _createClass(LaboratoryService, [{
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "fetchData", this).call(this, [{
                  patient: "Patient/".concat(this.patientId),
                  category: 'http://hl7.org/fhir/ValueSet/observation-category|laboratory'
                }].concat(_toConsumableArray(params)));

              case 2:
                data = _context.sent;
                return _context.abrupt("return", mapFromFHIR(data));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "fetchNextData",
    value: function () {
      var _fetchNextData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "fetchNextData", this).call(this);

              case 2:
                data = _context2.sent;
                return _context2.abrupt("return", mapFromFHIR(data));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchNextData() {
        return _fetchNextData.apply(this, arguments);
      }

      return fetchNextData;
    }()
  }, {
    key: "upsertData",
    value: function () {
      var _upsertData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var idMap, leukocytesObservationToUpsert, hemoglobinObservationToUpsert, plateletsObservationToUpsert, lymphocytesObservationToUpsert, neutrophilsObservationToUpsert, eosinophilsObservationToUpsert, basophilsObservationToUpsert, monocytesObservationToUpsert, observationIds, sbcPanelObservationToUpsert;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                idMap = {}; // Leukocytes

                leukocytesObservationToUpsert = mapToFHIRLeukocytes(data);
                _context3.next = 4;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, leukocytesObservationToUpsert);

              case 4:
                idMap.leukocytes = _context3.sent;
                // Hemoglobin
                hemoglobinObservationToUpsert = mapToFHIRHemoglobin(data);
                _context3.next = 8;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, hemoglobinObservationToUpsert);

              case 8:
                idMap.hemoglobin = _context3.sent;
                // Platelets
                plateletsObservationToUpsert = mapToFHIRPlatelets(data);
                _context3.next = 12;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, plateletsObservationToUpsert);

              case 12:
                idMap.platelets = _context3.sent;
                // Lymphocytes
                lymphocytesObservationToUpsert = mapToFHIRLymphocytes(data);
                _context3.next = 16;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, lymphocytesObservationToUpsert);

              case 16:
                idMap.lymphocytes = _context3.sent;
                // Neutrophils
                neutrophilsObservationToUpsert = mapToFHIRNeutrophils(data);
                _context3.next = 20;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, neutrophilsObservationToUpsert);

              case 20:
                idMap.neutrophils = _context3.sent;
                // Eosinophils
                eosinophilsObservationToUpsert = mapToFHIREosinophils(data);
                _context3.next = 24;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, eosinophilsObservationToUpsert);

              case 24:
                idMap.eosinophils = _context3.sent;
                // Basophils
                basophilsObservationToUpsert = mapToFHIRBasophils(data);
                _context3.next = 28;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, basophilsObservationToUpsert);

              case 28:
                idMap.basophils = _context3.sent;
                // Monocytes
                monocytesObservationToUpsert = mapToFHIRMonocytes(data);
                _context3.next = 32;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, monocytesObservationToUpsert);

              case 32:
                idMap.monocytes = _context3.sent;
                // Short Blood Count Panel
                observationIds = Object.values(idMap).filter(function (v) {
                  return !!v;
                });
                sbcPanelObservationToUpsert = mapToFHIRSBCPanel(data, observationIds);
                _context3.next = 37;
                return _get(_getPrototypeOf(LaboratoryService.prototype), "upsertData", this).call(this, sbcPanelObservationToUpsert);

              case 37:
                idMap.panel = _context3.sent;
                return _context3.abrupt("return", idMap);

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsertData(_x2) {
        return _upsertData.apply(this, arguments);
      }

      return upsertData;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LaboratoryService;
}(BaseResourceService);

export { LaboratoryService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LaboratoryService, "LaboratoryService", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/services/LaboratoryService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();